'use client'

import { registerPlugin } from '@capacitor/core'
import { isNativeCapacitorApp } from '@/lib/pwa/isNativeCapacitorApp'

export interface NativeTouchRecoveryPlugin {
  recover(options?: { reason?: string }): Promise<{
    ok: boolean
    reason?: string
    dismissedPresented?: boolean
    removedOverlays?: number
    webViewInteractionEnabled?: boolean
    rootInteractionEnabled?: boolean
    windowInteractionEnabled?: boolean
    presentedViewController?: string | null
  }>
}

const NativeTouchRecovery = registerPlugin<NativeTouchRecoveryPlugin>('NativeTouchRecovery')

/** Ask native iOS to restore WKWebView touch delivery after StoreKit / SFVC flows. */
export async function recoverNativeTouchHandling(reason: string): Promise<void> {
  if (typeof window === 'undefined' || !isNativeCapacitorApp()) return

  try {
    const result = await NativeTouchRecovery.recover({ reason })
    console.log('[NativeTouchDebug] js_recover ' + JSON.stringify(result))
  } catch (error) {
    console.warn('[NativeTouchDebug] js_recover_failed', { reason, error })
  }
}
